import React from "react";
import CustomerOrders from "../../components/user/Orders";
import Layout from "../../components/user/Layout";

function MyOrderPage() {
  return (
     <Layout>

      <CustomerOrders />

    </Layout>
  );
}

export default MyOrderPage;
